import { isHealthFeature } from "./HealthReport.types";
export const formatLeafCount = (node) => {
  if (!node.total_affected) return void 0;
  if (typeof node.total === "number") return `${node.total_affected}/${node.total}`;
  return `${node.total_affected}`;
};
export const formatLeafCountVerbose = (node, noun) => {
  if (!node.total_affected) return void 0;
  const nounPart = noun ? ` ${noun}` : "";
  if (typeof node.total === "number") return `${node.total_affected} of ${node.total}${nounPart} affected`;
  return `${node.total_affected}${nounPart} affected`;
};
export const countContainedChecks = (node) => {
  if (!isHealthFeature(node)) return 1;
  return node.children.reduce((count, child) => count + countContainedChecks(child), 0);
};
export const collectUnhealthyExpansionIds = (node) => {
  if (!isHealthFeature(node) || node.status === "healthy") return [];
  return [node.id, ...node.children.flatMap(collectUnhealthyExpansionIds)];
};
export const collectDescendantFeatureIds = (node) => {
  if (!isHealthFeature(node)) return [];
  return node.children.flatMap(
    (child) => isHealthFeature(child) ? [child.id, ...collectDescendantFeatureIds(child)] : []
  );
};
